import baseStyles from '../Base/Base.styles';
import merge from 'lodash/merge';
import {parseResponsiveProperty} from '@converdy/styles';
import baseTextStyles from '../BaseText/BaseText.styles';
import {responsiveTextAlignment} from '../Base/responsiveAlignment';

function toRatio(ratioString) {
  let imageRatio = ratioString.split('/');
  return (imageRatio[1] / imageRatio[0]) * 100;
}

export default ({
  base,
  borderColor,
  totalColor,
  totalTextColor,
  size,
  description,
}) => {
  let jss = {
    root: {
      ...baseStyles(base),
      '--border-color': borderColor,
      '--total-color': totalColor,
      '--total-text-color': totalTextColor,
      '--vertical-padding': '0px',
      '&': {
        ...responsiveTextAlignment(base.alignment),
      },
      '& .description': {
        ...baseTextStyles(description),
      },
      ...merge(
        parseResponsiveProperty(
          (c) => ({
            '--size': `${c}px`,
          }),
          size,
        ),
      ),
    },
  };

  return jss;
};
